import { Link } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { ICorporatePricingProfile } from 'pricing/types';

interface IProps extends ICellRendererParams {
  onNameClick: (data: ICorporatePricingProfile) => void;
}

export const NameCell = ({ value, data, onNameClick }: IProps) => {
  if (!value) {
    return <>{DEFAULT_PLACEHOLDER}</>;
  }

  const handleClick = () => {
    if (data) {
      onNameClick(data);
    }
  };

  return (
    <Link component="button" fontSize={14} onClick={handleClick}>
      {value}
    </Link>
  );
};
